import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setCurrentSite } from 'store/current-site/actions'
import fireRollCallActions from 'store/fire-roll-call/actions'
import siteActions from 'store/sites/actions'
import SiteList from './SiteList'

const mapStateToProps = state => ({
  sites: state.sites.list,
  currentSite: state.currentSite,
  loading: state.sites.loading,
  searched: state.sites.searched
})

const mapDispatchToProps = dispatch => ({
  selectSite: (site) => {
    dispatch(setCurrentSite(site))
    dispatch({ type: fireRollCallActions.fetchFireRollCall, site })
    dispatch({ type: siteActions.resetSites })
  }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiteList))



// WEBPACK FOOTER //
// ./src/components/SiteList/index.js